import { Component } from '@angular/core';
import { MainPage, NavController, ToastController, ErrorResult, LocalStorageService, AlertController, App } from '../mainpage';
import { UserService, ActionResult } from '../../providers/user';

@Component({
    selector: 'page-newticket',
    templateUrl: 'newticket.html'
  })
  export class NewTicketPage extends MainPage {
    
    public ticketName: string = "";

    constructor(public navCtrl: NavController, public toastController: ToastController, 
        public localStorage: LocalStorageService, public userService: UserService, 
        protected alertController: AlertController, public appCtrl: App) {
        super(navCtrl, toastController, localStorage, alertController, userService, appCtrl);
        this.loadPage();
    };

    public loadPage(): void {
        if (!this.CurrentChampionship.SubscriptionStatus) {
            this.presentToast("Campeonato não está aberto para novos cadastros!");
            this.navCtrl.pop();
        }
    };

    public crateTicket(): void {
        this.ticketName = this.ticketName.trim();
        if(this.ticketName.length > 0) {
            this.userService.insertTicket(this.ticketName).then((data: ActionResult) => {
                this.currentUser.User.Tickets = data.Item;
                this.saveUser();
                this.reloadTickets();
                this.presentToast("Bem Vindo ao campeonato " + this.CurrentChampionship.Name + " verifique os métodos de pagamento para efetivar sua inscrição!");
                this.navCtrl.pop();
              }).catch((err) => {
                this.getError(<ErrorResult>err);
              });        
        } 
        else {
            this.presentToast("Informe o nome da pedra!");
        }
    };

  }


// WEBPACK FOOTER //
// ./src/pages/newticket/newticket.ts